import { t } from "i18next";
import { useState } from "react";
import { useSelector } from "react-redux";

import { CustomButton } from "../../components/CustomButton/CustomButton";
import { FloatingButtons } from "../../components/FloatingButtons/FloatingButtons";
import { MultiselectRoles } from "../../components/Multiselect/MultiselectRoles";
import { RootState } from "../../store";
import styles from "../../styles/choose-objects.module.css";
import { formatPropertyLabel } from "../../utils/parseAddress";

interface ChooseMultipleObjectProps {
  onConfirm?: (selected: any) => void;
  selected: string[];
}

export const ChooseMultipleObject = ({
  onConfirm,
  selected,
}: ChooseMultipleObjectProps) => {
  const companyName = useSelector((state: RootState) => state.user.profileName);

  const reduxProperties = useSelector(
    (state: RootState) => state.user.properties
  );
  const { customerProperties, selectedCustomer } = useSelector(
    (state: RootState) => state.userManagement
  );

  const p =
    reduxProperties && reduxProperties.length > 0
      ? reduxProperties
      : customerProperties || [];

  const properties = p.map((property) => ({
    value: property.id,
    label: formatPropertyLabel(property),
  }));
  const [selectedProperties, setSelectedProperties] = useState<any>(
    () =>
      selected
        .map((value) => {
          const property = properties.find(
            (property: any) => property.value === value
          );
          return property
            ? { value: property.value, label: property.label }
            : null;
        })
        .filter(Boolean) || []
  );

  const handleObjectSelection = (selected: string[]) => {
    const selectedPropertiesWithLabels = selected
      .map((value) => {
        const property = properties.find(
          (property: any) => property.value === value
        );
        return property
          ? { value: property.value, label: property.label }
          : null;
      })
      .filter((property) => property !== null);

    setSelectedProperties(selectedPropertiesWithLabels);
  };

  const handleButtonClick = () => {
    if (onConfirm) {
      onConfirm(selectedProperties);
    }
  };

  return (
    <div>
      <div className={`${styles["card-wrapper"]}`}>
        <div className={`${styles["card"]}`}>
          <p className={`${styles["p"]}`}>{customerProperties.length > 0 ? selectedCustomer?.name : companyName}</p>

          <p className={`${styles["p-grayed"]}`}>Objekt auswählen:</p>
          <MultiselectRoles
            options={properties}
            onSelect={handleObjectSelection}
            showAdmin={false}
            initialSelectedOptions={selected}
          />
        </div>
      </div>

      <FloatingButtons>
        <CustomButton color="green" width={60} onClick={handleButtonClick}>
          {t("Add")}
        </CustomButton>
      </FloatingButtons>
    </div>
  );
};
